import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userType: "BUYERS",
};

const HomeSlice = createSlice({
  name: "home",
  initialState,
  reducers: {
    // Define your reducers here if needed
    resetHomeState: (state) => {
      return initialState; // Reset to initial state
    },
    setUserType: (state, action) => {
      state.userType = action.payload; // Update user type
    },
  },
});

export const { resetHomeState, setUserType } = HomeSlice.actions;
export default HomeSlice.reducer;
